module.exports = __webpack_public_path__ + "img/2.e737ca18.svg";